const createFunctionWithTimeout = (callback = () => {}, opt_timeout = 1000) => {
  let called = false;
  const fn = () => {
    if (called) return;
    called = true;
    callback();
  };
  setTimeout(fn, opt_timeout);
  return fn;
};

const setsUserID = (state) => ({
  setUserId: (userId) => ga(`${state.name}.set`, "userId", userId),
});

const setsDimension = (state) => ({
  setDimension: (dimensionValue, dimensionSlot) => ga(`${state.name}.set`, `dimension${dimensionSlot}`, dimensionValue),
});

const setsCD = (state) => ({
  setCD: (dimensionValue) => state.CDSlot && ga(`${state.name}.set`, state.CDSlot, dimensionValue),
  unsetCD: () => state.CDSlot && ga(`${state.name}.set`, state.CDSlot, null),
});

const sendsEvents = (state) => ({
  sendEvent: ({ eventAction, eventLabel, location }, trigger) =>
    ga(`${state.name}.send`, "event", {
      eventCategory: "almaTunnus",
      eventAction,
      eventLabel,
      nonInteraction: state.nonInteraction,
      location,
      page: location,
      hitCallback: createFunctionWithTimeout(trigger?.countDown, 1000),
    }),
});

export const CustomTracker = (name, account, CDSlot, nonInteraction) => {
  ga("create", account, { cookieDomain: "auto", name });
  const state = {
    name,
    account,
    CDSlot,
    nonInteraction,
  };
  return Object.assign({ state }, setsDimension(state), setsCD(state), setsUserID(state), sendsEvents(state));
};

export default (name, account, nonInteraction) => {
  ga("create", account, { cookieDomain: "auto", name });
  const state = {
    name,
    account,
    nonInteraction,
  };

  return Object.assign({ state }, setsDimension(state), setsUserID(state), sendsEvents(state));
};
